import * as React from 'react';
import { Navigate } from 'react-router';
import { useAppSelector } from 'store/store';
import { APP_ROUTES } from 'constants/routes';
import { TAdminRoute } from './AdminRoute.types';
import { EUserRoles } from 'api/users/users.types';

export const AdminRoute: TAdminRoute = ({ children }) => {
  const { data: currentUser } = useAppSelector(
    (state) => state.users.currentUser
  );

  if (currentUser?.role !== EUserRoles.ADMIN) {
    return <Navigate to={APP_ROUTES.HOME} />;
  }

  return children;
};
